import React from 'react';
import PrivateRoute from '../hoc/PrivateRoute/PrivateRoute';
import RendimentoMensalComercialPage from '../pages/AnaliseGerencial/RendimentoMensalComercial/RendimentoMensalComercialPage';
import ClientesEmDebitoPage from '../pages/AnaliseGerencial/ClientesEmDebito/ClientesEmDebitoPage';
import RendimentoMensalNegociadoresPage from '../pages/AnaliseGerencial/RendimentoMensalNegociadores/RendimentoMensalNegociadoresPage';
import ValoresAPagarPelaABEPage from '../pages/AnaliseGerencial/ValoresAPagarPelaABE/ValoresAPagarPelaABEPage';

function RoutesAnaliseGerencialComponents() {
  return (
    <>
      <PrivateRoute
        path="/analise-gerencial/rendimento-mensal-comercial"
        tipoUsuario="U"
        roles={['2401']}
        exact
        component={RendimentoMensalComercialPage}
      />
      <PrivateRoute
        path="/analise-gerencial/rendimento-mensal-negociadores"
        tipoUsuario="U"
        roles={['2401']}
        exact
        component={RendimentoMensalNegociadoresPage}
      />
      <PrivateRoute
        path="/analise-gerencial/clientes-em-debito"
        tipoUsuario="U"
        roles={['2401']}
        exact
        component={ClientesEmDebitoPage}
      />
      <PrivateRoute
        path="/analise-gerencial/valores-a-pagar-pela-abe"
        tipoUsuario="U"
        roles={['2401']}
        exact
        component={ValoresAPagarPelaABEPage}
      />
    </>
  );
}

export const RoutesAnaliseGerencial = RoutesAnaliseGerencialComponents;
